import React, { FC, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form, EMAIL_INVALID_MESSAGE } from '../../../..';
import { useStore } from '../../../../../common';

interface LogInFormProps {
	onSubmit: () => void;
}

const LogInForm: FC<LogInFormProps> = ({ onSubmit }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { email, password, errors } = state;

	const isSubmitDiabled = [!!email, !!password].some((i) => !i);

	const onEmailChange = (val: string) => {
		dispatch('EMAIL', val);
	};

	const onPasswordChange = (val: string) => {
		dispatch('PASS', val);
	};

	const submitHandler = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSubmit();
	};

	return (
		<Form errors={errors}>
			<form onSubmit={submitHandler}>
				<Input
					type='text'
					label='Email'
					value={email}
					placeholder='Enter your username or email here'
					dataId='email-field'
					onChange={onEmailChange}
					errorMessage={EMAIL_INVALID_MESSAGE}
				/>
				<Input
					type='password'
					label='Password'
					value={password}
					placeholder='Enter your password here'
					dataId='password-field'
					onChange={onPasswordChange}
				/>
				<Button type='submit' title='Sign in' fluid primary disabled={isSubmitDiabled} dataId='login-button' />
			</form>
		</Form>
	);
};

LogInForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
};

export { LogInForm };
